// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/supply_demand_gap_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/supply_demand_gap_model.proto.
 */
export const file_bffuser_v1_supply_demand_gap_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_google_type_decimal]);

/**
 * GapAreaSeries はエリア単位の時系列集計を保持する。
 * Mirrors internalapi.v1.GapAreaSeries.
 *
 * @generated from message bffuser.v1.GapAreaSeries
 */
export type GapAreaSeries = Message<"bffuser.v1.GapAreaSeries"> & {
  /**
   * エリアコード。
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * 時系列ポイント一覧。
   *
   * @generated from field: repeated bffuser.v1.GapTimePoint points = 2;
   */
  points: GapTimePoint[];

  /**
   * サブ期間サマリ (MONTH / YEAR range は日単位、DAY range はコマ単位で検出して返す)。
   *
   * @generated from field: repeated bffuser.v1.GapSubPeriodSummary sub_period_summaries = 3;
   */
  subPeriodSummaries: GapSubPeriodSummary[];
};

/**
 * Describes the message bffuser.v1.GapAreaSeries.
 * Use `create(GapAreaSeriesSchema)` to create a new message.
 */
export const GapAreaSeriesSchema: GenMessage<GapAreaSeries> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_demand_gap_model, 0);

/**
 * GapTimePoint は 1 時間軸 (コマ / 日) の需給ギャップ集計値。
 * Mirrors internalapi.v1.GapTimePoint.
 *
 * @generated from message bffuser.v1.GapTimePoint
 */
export type GapTimePoint = Message<"bffuser.v1.GapTimePoint"> & {
  /**
   * x 軸ラベル。DAY range: "00:00" 等、MONTH/YEAR range: "4/1" 等。
   *
   * @generated from field: string time_label = 1;
   */
  timeLabel: string;

  /**
   * 供給の動的カテゴリ内訳 (買い × 物理)。受渡区分 master 駆動で増減する。
   *
   * @generated from field: repeated bffuser.v1.GapTradeComponent supply = 2;
   */
  supply: GapTradeComponent[];

  /**
   * 供給合計 (MW)。= Σ supply.value_mw。精度敏感のため google.type.Decimal。
   *
   * @generated from field: google.type.Decimal supply_total_mw = 3;
   */
  supplyTotalMw?: Decimal;

  /**
   * 需要予測値 (MW)。DemandConfirmRecord 確定値。
   *
   * @generated from field: google.type.Decimal demand_forecast_mw = 4;
   */
  demandForecastMw?: Decimal;

  /**
   * 販売の動的カテゴリ内訳 (売り × 物理)。
   *
   * @generated from field: repeated bffuser.v1.GapTradeComponent sales = 5;
   */
  sales: GapTradeComponent[];

  /**
   * 需要 + 販売合計 (MW)。= demand_forecast_mw + Σ sales.value_mw。
   *
   * @generated from field: google.type.Decimal demand_plus_sales_mw = 6;
   */
  demandPlusSalesMw?: Decimal;

  /**
   * ポジション (MW)。= supply_total_mw − demand_plus_sales_mw。
   * 正値 = ロング (余剰供給)、 負値 = ショート (供給不足)。
   *
   * @generated from field: google.type.Decimal position_mw = 7;
   */
  positionMw?: Decimal;
};

/**
 * Describes the message bffuser.v1.GapTimePoint.
 * Use `create(GapTimePointSchema)` to create a new message.
 */
export const GapTimePointSchema: GenMessage<GapTimePoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_demand_gap_model, 1);

/**
 * GapTradeComponent は供給・販売の動的カテゴリ 1 件を表す。
 * 受渡区分 master 駆動のため、将来カテゴリ追加で proto 変更不要。
 * Mirrors internalapi.v1.GapTradeComponent.
 *
 * @generated from message bffuser.v1.GapTradeComponent
 */
export type GapTradeComponent = Message<"bffuser.v1.GapTradeComponent"> & {
  /**
   * カテゴリコード。受渡区分 code (BG/ECLEAR/BACKUP/JEPX...) または
   * "SPOT" / "INTRADAY" 等。
   *
   * @generated from field: string category_code = 1;
   */
  categoryCode: string;

  /**
   * 表示名 ("相対BG渡し" / "常時BU" / "スポット市場" 等)。
   *
   * @generated from field: string category_name = 2;
   */
  categoryName: string;

  /**
   * 取引由来。
   *
   * @generated from field: bffuser.v1.GapTradeOrigin origin = 3;
   */
  origin: GapTradeOrigin;

  /**
   * カテゴリ合計値 (MW)。精度敏感のため google.type.Decimal。
   *
   * @generated from field: google.type.Decimal value_mw = 4;
   */
  valueMw?: Decimal;
};

/**
 * Describes the message bffuser.v1.GapTradeComponent.
 * Use `create(GapTradeComponentSchema)` to create a new message.
 */
export const GapTradeComponentSchema: GenMessage<GapTradeComponent> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_demand_gap_model, 2);

/**
 * GapSubPeriodSummary はサブ期間 (週・月など) の代表値サマリ。
 * points と併せて返す (MONTH / YEAR range は日単位、DAY range はコマ単位)。
 * Mirrors internalapi.v1.GapSubPeriodSummary.
 *
 * @generated from message bffuser.v1.GapSubPeriodSummary
 */
export type GapSubPeriodSummary = Message<"bffuser.v1.GapSubPeriodSummary"> & {
  /**
   * サブ期間ラベル (例: "4/1-4/7")。
   *
   * @generated from field: string period_label = 1;
   */
  periodLabel: string;

  /**
   * true = ロング (売却上限)、 false = ショート (必要買い量)。
   *
   * @generated from field: bool is_long = 2;
   */
  isLong: boolean;

  /**
   * ベースロード代表値 (MW)。
   *
   * @generated from field: google.type.Decimal base_mw = 3;
   */
  baseMw?: Decimal;

  /**
   * ピーク代表値 (MW)。
   *
   * @generated from field: google.type.Decimal peak_mw = 4;
   */
  peakMw?: Decimal;

  /**
   * オフピーク代表値 (MW)。
   *
   * @generated from field: google.type.Decimal offpeak_mw = 5;
   */
  offpeakMw?: Decimal;

  /**
   * 安全売却量 (MW)。ロング区間の余剰の最小値 (= どのコマもショートさせずに
   * 売れる最大量)。ショート区間では 0。base_mw / peak_mw / offpeak_mw の代表
   * ポジション平均とは別の精密値 (#1375)。
   *
   * @generated from field: google.type.Decimal safe_sell_mw = 6;
   */
  safeSellMw?: Decimal;

  /**
   * 必要買い量 (MW)。ショート区間の不足の最大値 (= 最深ショートを 0 に戻すのに
   * 要する買い量、正の数)。ロング区間では 0。代表平均とは別の精密値 (#1375)。
   *
   * @generated from field: google.type.Decimal required_buy_mw = 7;
   */
  requiredBuyMw?: Decimal;
};

/**
 * Describes the message bffuser.v1.GapSubPeriodSummary.
 * Use `create(GapSubPeriodSummarySchema)` to create a new message.
 */
export const GapSubPeriodSummarySchema: GenMessage<GapSubPeriodSummary> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_demand_gap_model, 3);

/**
 * ProcurementNeedAreaSeries はエリア単位の 48 コマ調達必要量系列。
 * Mirrors internalapi.v1.ProcurementNeedAreaSeries.
 *
 * @generated from message bffuser.v1.ProcurementNeedAreaSeries
 */
export type ProcurementNeedAreaSeries = Message<"bffuser.v1.ProcurementNeedAreaSeries"> & {
  /**
   * エリアコード。
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * 48 コマ (koma 昇順) の調達必要量ポイント一覧。
   *
   * @generated from field: repeated bffuser.v1.ProcurementNeedPoint points = 2;
   */
  points: ProcurementNeedPoint[];
};

/**
 * Describes the message bffuser.v1.ProcurementNeedAreaSeries.
 * Use `create(ProcurementNeedAreaSeriesSchema)` to create a new message.
 */
export const ProcurementNeedAreaSeriesSchema: GenMessage<ProcurementNeedAreaSeries> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_demand_gap_model, 4);

/**
 * ProcurementNeedPoint は 1 コマの調達必要量。
 * Mirrors internalapi.v1.ProcurementNeedPoint.
 *
 * @generated from message bffuser.v1.ProcurementNeedPoint
 */
export type ProcurementNeedPoint = Message<"bffuser.v1.ProcurementNeedPoint"> & {
  /**
   * コマ番号 (1..48)。
   *
   * @generated from field: int32 koma_number = 1;
   */
  komaNumber: number;

  /**
   * 調達必要量 (MW)。正 = 買うべき量 / 負 = 売れる余剰。精度保持のため Decimal。
   *
   * @generated from field: google.type.Decimal need_mw = 2;
   */
  needMw?: Decimal;
};

/**
 * Describes the message bffuser.v1.ProcurementNeedPoint.
 * Use `create(ProcurementNeedPointSchema)` to create a new message.
 */
export const ProcurementNeedPointSchema: GenMessage<ProcurementNeedPoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_demand_gap_model, 5);

/**
 * GapRangeType は需給ギャップ集計の時間軸を指定する。
 * DAY: 1 日 48 コマ展開。MONTH: 月内日次。YEAR: 年内日次。
 * Mirrors internalapi.v1.GapRangeType.
 *
 * @generated from enum bffuser.v1.GapRangeType
 */
export enum GapRangeType {
  /**
   * @generated from enum value: GAP_RANGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 1 日分を 48 コマ (30 分粒度) で展開する。
   *
   * @generated from enum value: GAP_RANGE_TYPE_DAY = 1;
   */
  DAY = 1,

  /**
   * 月内を日次で展開する。
   *
   * @generated from enum value: GAP_RANGE_TYPE_MONTH = 2;
   */
  MONTH = 2,

  /**
   * 年内を日次で展開する。
   *
   * @generated from enum value: GAP_RANGE_TYPE_YEAR = 3;
   */
  YEAR = 3,
}

/**
 * Describes the enum bffuser.v1.GapRangeType.
 */
export const GapRangeTypeSchema: GenEnum<GapRangeType> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_supply_demand_gap_model, 0);

/**
 * GapRepresentativeValue は MONTH / YEAR range での代表値算出方式を指定する。
 * DAY range では無視される。
 * Mirrors internalapi.v1.GapRepresentativeValue.
 *
 * @generated from enum bffuser.v1.GapRepresentativeValue
 */
export enum GapRepresentativeValue {
  /**
   * @generated from enum value: GAP_REPRESENTATIVE_VALUE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ベースロード代表値 (全コマ平均)。
   *
   * @generated from enum value: GAP_REPRESENTATIVE_VALUE_BASE = 1;
   */
  BASE = 1,

  /**
   * ピーク代表値。
   *
   * @generated from enum value: GAP_REPRESENTATIVE_VALUE_PEAK = 2;
   */
  PEAK = 2,

  /**
   * オフピーク代表値。
   *
   * @generated from enum value: GAP_REPRESENTATIVE_VALUE_OFFPEAK = 3;
   */
  OFFPEAK = 3,
}

/**
 * Describes the enum bffuser.v1.GapRepresentativeValue.
 */
export const GapRepresentativeValueSchema: GenEnum<GapRepresentativeValue> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_supply_demand_gap_model, 1);

/**
 * GapTradeOrigin は GapTradeComponent の供給/販売の取引由来を表す。
 * Mirrors internalapi.v1.GapTradeOrigin.
 *
 * @generated from enum bffuser.v1.GapTradeOrigin
 */
export enum GapTradeOrigin {
  /**
   * @generated from enum value: GAP_TRADE_ORIGIN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 相対取引の受渡区分 (bilateral delivery type) 由来。
   *
   * @generated from enum value: GAP_TRADE_ORIGIN_BILATERAL_DELIVERY_TYPE = 1;
   */
  BILATERAL_DELIVERY_TYPE = 1,

  /**
   * スポット市場由来。
   *
   * @generated from enum value: GAP_TRADE_ORIGIN_SPOT = 2;
   */
  SPOT = 2,

  /**
   * 時間外取引 (イントラデイ) 由来。
   *
   * @generated from enum value: GAP_TRADE_ORIGIN_INTRADAY = 3;
   */
  INTRADAY = 3,
}

/**
 * Describes the enum bffuser.v1.GapTradeOrigin.
 */
export const GapTradeOriginSchema: GenEnum<GapTradeOrigin> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_supply_demand_gap_model, 2);

/**
 * ProcurementNeedMarket は調達必要量 (need) の算出対象市場を指定する。
 * Mirrors internalapi.v1.ProcurementNeedMarket.
 *
 * @generated from enum bffuser.v1.ProcurementNeedMarket
 */
export enum ProcurementNeedMarket {
  /**
   * @generated from enum value: PROCUREMENT_NEED_MARKET_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * スポット市場向け調達必要量。
   *
   * @generated from enum value: PROCUREMENT_NEED_MARKET_SPOT = 1;
   */
  SPOT = 1,

  /**
   * 時間前市場向け調達必要量 (= スポット後残差)。
   *
   * @generated from enum value: PROCUREMENT_NEED_MARKET_INTRADAY = 2;
   */
  INTRADAY = 2,
}

/**
 * Describes the enum bffuser.v1.ProcurementNeedMarket.
 */
export const ProcurementNeedMarketSchema: GenEnum<ProcurementNeedMarket> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_supply_demand_gap_model, 3);

